import { FallbackProps } from "react-error-boundary";

export default function Fallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre style={{ color: "red", fontSize: "10px", textAlign: "left" }}>{error.stack}</pre>
    </div>
  );
}
